import {ref} from 'vue'
import {BASE_URL} from "@/composables/url_config";
import {log} from "@/composables/useLog"
import axios from "axios";

const error = ref(null)

export const getAvailableMsisdnsList = async (token, options = {}) => {
    log("welcome in getAvailableMsisdnsList")

    if (!token || token === "") {
        alert("No token in getAvailableMsisdnsList")
        return {error: true, message: "No token provided", msisdns_list: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        log("BASE_URL=" + BASE_URL)
        let url = BASE_URL + '/home/get_available_msisdns_api'
        log("url=" + url)

        // Build query params
        const params = {}
        if (options.msisdn_class_id) {
            params.msisdn_class_id = options.msisdn_class_id
        }
        if (options.msisdn_like) {
            params.msisdn_like = options.msisdn_like
        }
        if (options.limit) {
            params.limit = options.limit
        }

        const result = await axios.get(url, {headers: headers, params})
        log("result.data din axios getAvailableMsisdnsList")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getAvailableMsisdnsList")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getAvailableMsisdnsList", msisdns_list: []}
    }
}

export const checkMsisdnAvailability = async (token, msisdnId) => {
    log("welcome in checkMsisdnAvailability for msisdn_id=" + msisdnId)

    if (!token || token === "") {
        return {error: true, available: false, message: "No token provided"}
    }

    if (!msisdnId) {
        return {error: true, available: false, message: "No msisdn_id provided"}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/check_msisdn_availability_api'
        log("url=" + url)

        const result = await axios.get(url, {headers: headers, params: {msisdn_id: msisdnId}})
        log("result.data from checkMsisdnAvailability")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in checkMsisdnAvailability")
        log(err)
        error.value = err.message
        return {error: true, available: false, message: "Error checking MSISDN availability"}
    }
}

export const getMsisdnClasses = async (token) => {
    log("welcome in getMsisdnClasses")

    if (!token || token === "") {
        return {error: true, message: "No token provided", msisdns_classes: []}
    }

    try {
        const headers = {
            "Authorization": `Bearer ${token}`,
            "Content-Type": "application/json",
            "Accept": "application/json"
        }

        let url = BASE_URL + '/home/get_msisdns_classes_api'
        log("url=" + url)

        const result = await axios.get(url, {headers: headers})
        log("result.data din axios getMsisdnClasses")
        log(result.data)

        return result.data
    } catch (err) {
        log("Error in getMsisdnClasses")
        log(err)
        error.value = err.message
        return {error: true, message: "Eroare la getMsisdnClasses", msisdns_classes: []}
    }
}

const useGetAvailableMsisdnsAPI = () => {
    return {error, getAvailableMsisdnsList, getMsisdnClasses}
}

export default useGetAvailableMsisdnsAPI
